import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import moment from 'moment';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { IsSingleDay, addLastDateRequestValue, formatFilterValues, formatSingleTime, otherParamsVal } from '@/pages/dashboard/utils/utils';
import { getDefaultUtcDateValue } from "@/pages/dashboard/utils/dateUtils";
import KeyMetrics from './KeyMetrics';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';
import './index.scss';

export default function KeyMetricsService(props: any) {
  const { style, className, type, config,switchData,  ...restProps } = props || {};
  const timeZone = parseInt(props?.data?.time_zone || '', 10) || 0;
  const { api, mainMetricsList = [], metricsList = [], isDark = false, haveJump = false, height = 460, haveLastDate,
    isChangeHeight = 424, isSingle = false, refreshKey = '', interval, isSalesOverview = false,
    isComplete = true, isConfirm, dateFilterIsRange, otherParams: otherParamsData, formatData, formatRules, 
    dateFilterType = 'rangeDateFilter', loadingHeight } = config || {};

  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code,
  }), shallowEqual);

  const data = useMemo(() => ({
    gameCode,
    metricsList,
    mainMetricsList,
    isDark,
    haveJump,
    height,
    isChangeHeight,
    cardTitleSwitchVal: switchData?.cardTitleSwitchVal,
    loadingHeight,
    ...props.data,
  }), [gameCode, metricsList, mainMetricsList, isDark, haveJump, height, isChangeHeight, switchData?.cardTitleSwitchVal, props.data]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        refreshKey={refreshKey}
        interval={interval}
        dataKey={'keyMetricsData'}
        formatRules={formatRules}
        formatData={formatData}
        beforeRequest={(data) => {
          const { filterVal, gameCode, mainMetricsList, metricsList } = data;
          const { timeType, diff, rangeTime, selector, newFilter, contrastDaily, singleDaily, ...filters } = filterVal || {};
          const period = PERIODTIMEOBJ?.[timeType];
          const defaultTimeRange = getDefaultUtcDateValue(timeType, rangeTime, dateFilterIsRange);
          const rangeTimeArr = diff ? defaultTimeRange : rangeTime;
          const filtersVal = formatFilterValues(filters);
          const otherParams = otherParamsVal(otherParamsData, filtersVal) || {};
          const onlySingleDateFilter = dateFilterType === 'singleDaily';
          const [start, end] = rangeTimeArr || ['', ''];

          let params = {
            game_code: gameCode,
            period,
            filters: filtersVal,
            start_time: start,
            end_time: end,
            is_confirm: !diff,
            metrics: metricsList,
            trend_metrics: mainMetricsList,
            ...(otherParams || {})
          };
          // 夜莺框架单天筛选器特殊逻辑添加
          if (isSingle) {
            params.is_confirm = false;
            params.start_time = moment(rangeTime?.[0]).subtract(6, 'days').format('YYYY-MM-DD');
            params.end_time = rangeTime?.[1];
          }
          if (isSalesOverview) {
            params.page_path = "/monetization/salesOverview";
            params.is_confirm = true;
          }
          // 开启补齐逻辑 并且非特殊页面
          if (isComplete && !isSingle && !isSalesOverview) {
            const single = IsSingleDay({ rangeTime, period });
            const rangeTimeArr = diff ? defaultTimeRange : formatSingleTime(rangeTime, timeType);
            const [start, end] = rangeTimeArr || ['', ''];
            params.start_time = onlySingleDateFilter ? end : start;
            params.end_time = end;
            // 如果是单日单周单月 都视为没点击过筛选器（用于判断指标卡片数值是否取最后一天数据）
            params.is_confirm = single ? false : !diff;
          }
          if (isConfirm) {
            const single = IsSingleDay({ rangeTime, period });
            params.is_confirm = !single;
          }
          if(onlySingleDateFilter) {
            const singleTimeRange = getDefaultUtcDateValue(timeType, [singleDaily, singleDaily], false);
            params.start_time = contrastDaily? singleTimeRange?.[1] : singleTimeRange?.[0];
            params.end_time = singleTimeRange?.[1];
          }
          params = addLastDateRequestValue(params, haveLastDate, timeZone);
          return params;
        }}
        trackData={['gameCode', 'metricsList', 'mainMetricsList', 'isDark', 'cardTitleSwitchVal']}>
        <KeyMetrics {...restProps}></KeyMetrics>
      </Service>
    </div>
  );
};
